import { render, staticRenderFns } from "./CampagnaFilter.vue?vue&type=template&id=4a405578&"
import script from "./CampagnaFilter.vue?vue&type=script&lang=ts&"
export * from "./CampagnaFilter.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports